import React from 'react';
import { Settings, MessageSquare, MapPin, Calendar, Phone, Shield, Database } from 'lucide-react';
export function Config() {
  const sections = [{
    title: 'Integraciones',
    icon: <Settings className="w-5 h-5 text-growthly-text" data-id="element-630" />,
    items: [{
      name: 'WhatsApp Business API',
      status: 'Conectado',
      icon: <MessageSquare className="w-4 h-4" data-id="element-631" />
    }, {
      name: 'Google My Business',
      status: 'Conectado',
      icon: <MapPin className="w-4 h-4" data-id="element-632" />
    }, {
      name: 'Google Calendar',
      status: 'Conectado',
      icon: <Calendar className="w-4 h-4" data-id="element-633" />
    }, {
      name: 'Telefonía (Twilio)',
      status: 'Pendiente',
      icon: <Phone className="w-4 h-4" data-id="element-634" />
    }]
  }, {
    title: 'Privacidad y GDPR',
    icon: <Shield className="w-5 h-5 text-growthly-text" data-id="element-635" />,
    items: [{
      name: 'Políticas de Retención',
      status: 'Configurado',
      icon: <Database className="w-4 h-4" data-id="element-636" />
    }, {
      name: 'Flujos DSAR (Export/Delete)',
      status: 'Activo',
      icon: <Shield className="w-4 h-4" data-id="element-637" />
    }]
  }];
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-638">
      <div className="flex items-center justify-between" data-id="element-639">
        <div data-id="element-640">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-641">
            Configuración
          </h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-642">
            Gestiona integraciones y ajustes del sistema.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-643">
        {sections.map((section, idx) => <div key={idx} className="card overflow-hidden" data-id="element-644">
            <div className="p-4 border-b border-white/5 flex items-center space-x-2 bg-growthly-panel" data-id="element-645">
              {section.icon}
              <h3 className="text-[14px] font-semibold text-growthly-text" data-id="element-646">
                {section.title}
              </h3>
            </div>
            <div className="divide-y divide-white/5" data-id="element-647">
              {section.items.map((item, itemIdx) => <div key={itemIdx} className="p-4 flex items-center justify-between hover:bg-white/[0.02] transition-colors" data-id="element-648">
                  <div className="flex items-center space-x-3" data-id="element-649">
                    <div className="w-8 h-8 rounded bg-white/5 flex items-center justify-center text-growthly-muted" data-id="element-650">
                      {item.icon}
                    </div>
                    <span className="text-[13px] font-medium text-growthly-text" data-id="element-651">
                      {item.name}
                    </span>
                  </div>
                  <span className={`text-[11px] font-medium px-2 py-1 rounded ${item.status === 'Conectado' || item.status === 'Activo' || item.status === 'Configurado' ? 'bg-growthly-green/20 text-growthly-green' : 'bg-growthly-amber/20 text-growthly-amber'}`} data-id="element-652">
                    {item.status}
                  </span>
                </div>)}
            </div>
          </div>)}
      </div>
    </div>;
}